(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["music-slider"] && !Shopify.designMode) return;
  try {
    
  /* Arrows are an enhancement. Touch scrolling, keyboard tabbing, and the
     links themselves all work if this never runs. */
  if (!customElements.get('release-slider')) {
    class ReleaseSlider extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        this.nav = this.querySelector('[data-nav]');
        if (!this.rail || !this.nav) return;

        this.arrows = Array.from(this.nav.querySelectorAll('[data-scroll]'));

        this.arrows.forEach((btn) => {
          btn.addEventListener('click', () => {
            const card = this.rail.querySelector('.release-slider__card');
            const gap = parseInt(getComputedStyle(this.rail).columnGap, 10) || 12;
            const step = card ? card.offsetWidth + gap : this.rail.clientWidth * 0.8;
            this.rail.scrollBy({ left: step * Number(btn.dataset.scroll) });
          });
        });

        this.update = this.update.bind(this);
        this.rail.addEventListener('scroll', this.update, { passive: true });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.update);
          this.ro.observe(this.rail);
        } else {
          window.addEventListener('resize', this.update);
        }

        this.update();
      }

      disconnectedCallback() {
        if (this.rail) this.rail.removeEventListener('scroll', this.update);
        if (this.ro) this.ro.disconnect();
        window.removeEventListener('resize', this.update);
      }

      update() {
        const overflows = this.rail.scrollWidth > this.rail.clientWidth + 4;
        this.nav.hidden = !overflows;
        if (!overflows) return;

        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const x = this.rail.scrollLeft;
        this.arrows.forEach((btn) => {
          const back = Number(btn.dataset.scroll) < 0;
          btn.disabled = back ? x <= 2 : x >= max - 2;
        });
      }
    }

    customElements.define('release-slider', ReleaseSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tour-dates"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tour-dates')) {
    const CACHE_MS = 15 * 60 * 1000;

    class TourDates extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-live')) return;

        this.list = this.querySelector('[data-list]');
        this.loading = this.querySelector('[data-loading]');
        this.empty = this.querySelector('[data-empty]');

        this.candidates = this.buildCandidates();
        if (this.candidates.length === 0) return;

        this.appId = this.dataset.appId;
        this.limit = parseInt(this.dataset.limit, 10) || 10;
        this.params = this.dataset.params || '';
        this.newTab = this.dataset.newTab === 'true';
        this.buttonLabel = this.dataset.buttonLabel || 'Get Tickets';
        this.soldOutLabel = this.dataset.soldoutLabel || 'Sold Out';
        this.showTime = this.dataset.showTime === 'true';

        this.fetchEvents();
      }

      /* Accepts a Bandsintown artist URL, a numeric ID, an id_ string, or a
         plain artist name. The numeric ID is preferred — it survives artist
         name changes and sidesteps encoding issues entirely. */
      resolveArtist(raw) {
        const v = String(raw || '').trim();
        if (!v) return '';

        const byId = v.match(/bandsintown\.com\/a\/(\d+)/i);
        if (byId) return 'id_' + byId[1];

        if (/^id_\d+$/i.test(v)) return v.toLowerCase();
        if (/^\d+$/.test(v)) return 'id_' + v;

        const bySlug = v.match(/bandsintown\.com\/([^/?#]+)/i);
        if (bySlug) return encodeURIComponent(decodeURIComponent(bySlug[1]));

        // Bandsintown wants / and ? double-encoded inside artist names.
        return encodeURIComponent(v).replace(/%2F/g, '%252F').replace(/%3F/g, '%253F');
      }

      buildCandidates() {
        const list = [];
        const fromUrl = this.resolveArtist(this.dataset.artistUrl);
        const fromName = this.resolveArtist(this.dataset.artist);
        if (fromUrl) list.push(fromUrl);
        if (fromName && fromName !== fromUrl) list.push(fromName);
        return list;
      }

      cacheKey() {
        return 'td:' + this.candidates[0] + ':' + this.limit;
      }

      readCache() {
        try {
          const raw = sessionStorage.getItem(this.cacheKey());
          if (!raw) return null;
          const { at, data } = JSON.parse(raw);
          if (Date.now() - at > CACHE_MS) return null;
          return data;
        } catch (e) {
          return null;
        }
      }

      writeCache(data) {
        try {
          sessionStorage.setItem(this.cacheKey(), JSON.stringify({ at: Date.now(), data }));
        } catch (e) {
          /* storage full or blocked — not worth failing over */
        }
      }

      async fetchEvents() {
        const cached = this.readCache();
        if (cached) {
          this.render(cached);
          return;
        }

        let lastError = null;

        // Try the ID form first, then the name. If the ID lookup ever stops
        // working, the section keeps running on the name instead of going dark.
        for (const identifier of this.candidates) {
          const url =
            'https://rest.bandsintown.com/artists/' +
            identifier +
            '/events/?app_id=' +
            encodeURIComponent(this.appId) +
            '&date=upcoming';

          try {
            const res = await fetch(url, { headers: { Accept: 'application/json' } });
            if (!res.ok) throw new Error('HTTP ' + res.status + ' for ' + identifier);

            const data = await res.json();
            if (!Array.isArray(data)) throw new Error('Unexpected response shape for ' + identifier);

            this.writeCache(data);
            this.render(data);
            return;
          } catch (err) {
            lastError = err;
          }
        }

        // Leave whatever was server-rendered in place. A stale fallback
        // list beats an empty section.
        console.warn('Tour dates: falling back to manual list.', lastError);
        if (this.loading) this.loading.hidden = true;
        if (this.list && this.list.children.length === 0 && this.empty) {
          this.empty.hidden = false;
        }
      }

      render(events) {
        if (this.loading) this.loading.hidden = true;

        const upcoming = events.slice(0, this.limit);

        if (upcoming.length === 0) {
          this.list.hidden = true;
          if (this.empty) this.empty.hidden = false;
          return;
        }

        this.list.replaceChildren(...upcoming.map((e) => this.buildRow(e)));
        this.list.hidden = false;
        if (this.empty) this.empty.hidden = true;
      }

      withParams(url) {
        if (!this.params || !url) return url;
        return url + (url.indexOf('?') > -1 ? '&' : '?') + this.params;
      }

      /* Everything below builds DOM nodes and sets textContent — API strings
         are never written as HTML, so a venue name with markup in it can't
         inject anything. */
      el(tag, className, text) {
        const n = document.createElement(tag);
        if (className) n.className = className;
        if (text != null) n.textContent = text;
        return n;
      }

      buildRow(e) {
        const li = this.el('li', 'tour-dates__row');

        // Bandsintown returns venue-local time with no offset, which is what
        // we want to display, so let the Date parse as local.
        const dt = e.datetime ? new Date(e.datetime) : null;
        const valid = dt && !isNaN(dt.getTime());

        if (valid) {
          const cal = this.el('div', 'tour-dates__cal');
          cal.appendChild(
            this.el('span', 'tour-dates__cal-weekday', dt.toLocaleDateString(undefined, { weekday: 'long' }))
          );
          const body = this.el('span', 'tour-dates__cal-body');
          body.appendChild(
            this.el('span', 'tour-dates__cal-month', dt.toLocaleDateString(undefined, { month: 'short' }))
          );
          body.appendChild(this.el('span', 'tour-dates__cal-day', String(dt.getDate())));
          cal.appendChild(body);
          li.appendChild(cal);
        }

        const info = this.el('div', 'tour-dates__info');
        const venue = e.venue || {};

        const name = venue.name || e.title || '';
        if (name) info.appendChild(this.el('span', 'tour-dates__venue', name));

        const place = [venue.city, venue.region || venue.country].filter(Boolean).join(', ');
        if (place) info.appendChild(this.el('span', 'tour-dates__meta', place));

        if (this.showTime && valid) {
          const time = this.el(
            'time',
            'tour-dates__meta',
            dt.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' })
          );
          time.setAttribute('datetime', e.datetime);
          info.appendChild(time);
        }

        li.appendChild(info);

        const offers = Array.isArray(e.offers) ? e.offers : [];
        const offer = offers.find((o) => o.type === 'Tickets') || offers[0];
        const soldOut = !!(offer && String(offer.status || '').toLowerCase().indexOf('sold') > -1);
        const href = (offer && offer.url) || e.url;

        const action = this.el('div', 'tour-dates__action');

        if (soldOut) {
          const span = this.el('span', 'tour-dates__btn tour-dates__btn--disabled', this.soldOutLabel);
          span.setAttribute('aria-disabled', 'true');
          action.appendChild(span);
        } else if (href) {
          const a = this.el('a', 'tour-dates__btn', this.buttonLabel);
          a.href = this.withParams(href);
          if (this.newTab) {
            a.target = '_blank';
            a.rel = 'noopener';
          }
          if (name) {
            a.appendChild(this.el('span', 'visually-hidden', ' for ' + name));
          }
          action.appendChild(a);
        }

        li.appendChild(action);
        return li;
      }
    }

    customElements.define('tour-dates', TourDates);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-scroller"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-scroller')) {
    class VideoScroller extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-rail]');
        if (!this.rail) return;

        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        this.nav = this.querySelector('[data-nav]');

        this.tap = this.dataset.tap || 'lightbox';
        this.dialog = this.querySelector('[data-lightbox]');

        // <dialog> without showModal means no focus trap or Esc handling,
        // so fall back to loading the player in the card instead.
        if (this.tap === 'lightbox' && !(this.dialog && typeof this.dialog.showModal === 'function')) {
          this.tap = 'inline';
        }

        this.setupPosterFallback();
        this.setupArrows();
        this.setupFacade();
        this.setupLightbox();
        this.setupPreviews();
      }

      disconnectedCallback() {
        if (this.dialog && this.dialog.open) this.dialog.close();
        document.documentElement.classList.remove('vs-lightbox-open');
        if (this.io) this.io.disconnect();
        if (this.ro) this.ro.disconnect();
        if (this.rail) this.rail.removeEventListener('scroll', this.updateArrows);
        document.removeEventListener('visibilitychange', this.onVisibility);
        window.removeEventListener('resize', this.updateArrows);
      }

      /* maxresdefault doesn't exist for every video — fall back to hqdefault. */
      setupPosterFallback() {
        this.querySelectorAll('img[data-fallback]').forEach((img) => {
          img.addEventListener(
            'error',
            () => {
              img.src = img.dataset.fallback;
              img.removeAttribute('data-fallback');
            },
            { once: true }
          );
        });
      }

      /* ---- facade: swap in the real player on tap ---- */

      setupFacade() {
        const withEmbed = this.cards.filter((c) => c.dataset.embed);
        if (withEmbed.length === 0) return;

        // Warm the connection on first intent, not on page load.
        const warm = () => {
          ['https://www.youtube-nocookie.com', 'https://i.ytimg.com'].forEach((href) => {
            const l = document.createElement('link');
            l.rel = 'preconnect';
            l.href = href;
            document.head.appendChild(l);
          });
        };
        this.rail.addEventListener('pointerover', warm, { once: true });
        this.rail.addEventListener('touchstart', warm, { once: true, passive: true });

        withEmbed.forEach((card) => {
          card.addEventListener('click', () => {
            if (this.tap === 'lightbox') this.open(card);
            else this.load(card);
          });
        });
      }

      buildIframe(src, title) {
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = title || 'YouTube video player';
        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
        return iframe;
      }

      /* ---- lightbox ---- */

      setupLightbox() {
        if (!this.dialog || this.tap !== 'lightbox') return;

        this.lbFrame = this.dialog.querySelector('[data-lightbox-frame]');

        this.dialog.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());

        // Clicking the dimmed area closes; clicking the player does not.
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog || e.target.classList.contains('video-scroller__lightbox-inner')) {
            this.dialog.close();
          }
        });

        // Fires for the close button, the backdrop, and Esc alike.
        this.dialog.addEventListener('close', () => {
          this.lbFrame.replaceChildren();
          document.documentElement.classList.remove('vs-lightbox-open');
          if (this.lastCard) this.lastCard.focus();
        });
      }

      open(card) {
        if (!card.dataset.embed) return;

        this.lastCard = card;
        this.querySelectorAll('[data-preview]').forEach((v) => v.pause());

        this.lbFrame.replaceChildren(
          this.buildIframe(card.dataset.embed, card.getAttribute('aria-label'))
        );
        document.documentElement.classList.add('vs-lightbox-open');
        this.dialog.showModal();
      }

      load(card) {
        if (card.hasAttribute('data-loaded')) return;

        // Only one player at a time — tearing the old one down frees the
        // decoder and stops its audio.
        this.cards.forEach((c) => {
          if (c !== card && c.hasAttribute('data-loaded')) this.unload(c);
        });

        const frame = card.querySelector('[data-frame]');
        const preview = card.querySelector('[data-preview]');
        if (preview) preview.pause();

        frame.appendChild(this.buildIframe(card.dataset.embed, card.getAttribute('aria-label')));
        card.setAttribute('data-loaded', '');
      }

      unload(card) {
        const iframe = card.querySelector('iframe');
        if (iframe) iframe.remove();
        card.removeAttribute('data-loaded');
      }

      /* ---- optional silent previews ---- */

      setupPreviews() {
        const previews = Array.from(this.querySelectorAll('[data-preview]'));
        if (previews.length === 0) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (!('IntersectionObserver' in window)) return;

        const playCentered = () => {
          const mid = window.innerWidth / 2;
          let best = null;
          let bestDist = Infinity;

          previews.forEach((v) => {
            const r = v.getBoundingClientRect();
            if (r.right <= 0 || r.left >= window.innerWidth) {
              v.pause();
              return;
            }
            const d = Math.abs(r.left + r.width / 2 - mid);
            if (d < bestDist) {
              bestDist = d;
              best = v;
            }
          });

          previews.forEach((v) => {
            if (v !== best) v.pause();
          });

          if (best && best.paused && !best.closest('[data-loaded]')) {
            best.muted = true;
            const p = best.play();
            if (p && p.catch) p.catch(() => {});
          }
        };

        this.io = new IntersectionObserver(playCentered, { threshold: [0, 0.4, 0.8] });
        previews.forEach((v) => this.io.observe(v));

        this.rail.addEventListener('scrollend', playCentered);

        this.onVisibility = () => {
          if (document.hidden) previews.forEach((v) => v.pause());
        };
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      /* ---- arrows ---- */

      setupArrows() {
        if (!this.nav) return;
        this.arrows = Array.from(this.nav.querySelectorAll('[data-scroll]'));

        this.arrows.forEach((btn) => {
          btn.addEventListener('click', () => {
            const card = this.rail.querySelector('.video-scroller__card');
            const gap = parseInt(getComputedStyle(this.rail).columnGap, 10) || 12;
            const step = card ? card.offsetWidth + gap : this.rail.clientWidth * 0.8;
            this.rail.scrollBy({ left: step * Number(btn.dataset.scroll) });
          });
        });

        this.updateArrows = this.updateArrows.bind(this);
        this.rail.addEventListener('scroll', this.updateArrows, { passive: true });

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(this.updateArrows);
          this.ro.observe(this.rail);
        } else {
          window.addEventListener('resize', this.updateArrows);
        }

        this.updateArrows();
      }

      updateArrows() {
        const overflows = this.rail.scrollWidth > this.rail.clientWidth + 4;
        this.nav.hidden = !overflows;
        if (!overflows) return;

        const max = this.rail.scrollWidth - this.rail.clientWidth;
        const x = this.rail.scrollLeft;
        this.arrows.forEach((btn) => {
          const back = Number(btn.dataset.scroll) < 0;
          btn.disabled = back ? x <= 2 : x >= max - 2;
        });
      }
    }

    customElements.define('video-scroller', VideoScroller);
  }

  } catch(e) { console.error(e); }
})();
})();
